import * as Fathom from "fathom-client";

export const loadFathomTrackingId = () => {
  const trackingId = import.meta.env.VITE_FATHOM_ENV_ID;
  if (import.meta.env.NODE_ENV !== "development" && trackingId) {
    return Fathom.load(trackingId);
  } else return null;
};
